export enum AppealOutcome {
  PreviousOutcomeUpheld = "Previous outcome upheld",
  OutcomeUpdated = "Outcome updated",
  ReferredToDeForDecision = "Referred to DE for decision",
  Other = "Other (please specify)",
}
